import { Collapse, IconButton, Typography } from '@material-ui/core';
import React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

const BasicCollapsible = (props) => {
	return (
		<>
			{props.show ?
				(
					<div
						style={{
							backgroundColor: '#f7f7f7',
							padding: '10px',
							borderRadius: '20px',
							marginTop: '20px',
							marginBottom: '20px',
							minWidth: '50%',
						}}
					>
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-between',
								backgroundColor: 'primary',
								borderRadius: '40px',
								paddingLeft: '20px',
							}}
						>
							<div onClick={props.handleExpandClick} style={{ color: 'primary' }}>
								<Typography component='legend' color='primary'>
									<legend>{props.areaName}</legend>
								</Typography>
							</div>
							{props.expanded ? (
								<IconButton
									style={{ color: 'primary' }}
									onClick={props.handleExpandClick}
									aria-expanded={props.expanded}
									aria-label='show less'
								>
									<ExpandLessIcon />
								</IconButton>
							) : (
									<IconButton
										style={{ color: 'primary' }}
										onClick={props.handleExpandClick}
										aria-expanded={props.expanded}
										aria-label='show more'
									>
										<ExpandMoreIcon />
									</IconButton>
								)}
						</div>
						<Collapse style={{ padding: '20px' }} in={props.expanded} timeout='auto' unmountOnExit>
							{props.children}
						</Collapse>
					</div>
				) : <div></div>
			}
		</>
	)
};

export default BasicCollapsible;
